import { clsx } from 'clsx'
import { Helmet } from 'react-helmet-async'

import { Embed } from '@tribeplatform/gql-client/types'
import { useEmbed } from '@tribeplatform/react-sdk/hooks'
import { useColorSchemeContext } from '@tribeplatform/react-ui-kit/ThemeProvider'

interface Props {
  embed: Embed
}

export const MessageEmbedRenderer = ({ embed: initialEmbed }: Props) => {
  const { colorSchemeMode } = useColorSchemeContext()

  const { data: embed } = useEmbed({
    variables: {
      url: initialEmbed.url,
      options: JSON.stringify({
        iframe: '1',
        omit_script: '1',
        theme: colorSchemeMode ?? 'auto',
      }),
    },
    useQueryOptions: {
      initialData: initialEmbed,
      cacheTime: Infinity,
      staleTime: Infinity,
      enabled: !!initialEmbed?.html,
    },
  })

  const embedRendered = (
    <>
      <div className="preview relative w-full overflow-hidden rounded-base">
        {embed?.html ? (
          <figure
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: embed?.html }}
            className="rounded-base screen-rounded-none p-1"
          />
        ) : (
          <a
            href={embed.url}
            target="_blank"
            className={clsx('rounded-base screen-rounded-none overflow-hidden')}
          >
            {embed.url}
          </a>
        )}
      </div>
      <Helmet>
        <script src="//cdn.iframe.ly/embed.js?theme=dark" async></script>
      </Helmet>
    </>
  )

  if (embed?.type === 'video') {
    return <div className="aspect-video max-h-64">{embedRendered}</div>
  }

  return embedRendered
}
